import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PopoverMultiInstanceDynFormComponent } from './popover-multi-instance-dyn-form.component';
import { IonicModule } from '@ionic/angular';
import { SharedModule } from 'src/app/_shared/shared.module';
import { DataListModule } from '../data-list/data-list.module';
import { DataListComponent } from '../data-list/data-list.component';

@NgModule({
    imports: [CommonModule, IonicModule, SharedModule, DataListModule],
    declarations: [PopoverMultiInstanceDynFormComponent],
    exports: [PopoverMultiInstanceDynFormComponent]
})
export class PopoverMultiInstanceDynFormComponentModule {}
